(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("powerbi-client"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["powerbi-client", "react"], factory);
	else if(typeof exports === 'object')
		exports["react-powerbi-client"] = factory(require("powerbi-client"), require("react"));
	else
		root["react-powerbi-client"] = factory(root["powerbi-client"], root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_powerbi_client__, __WEBPACK_EXTERNAL_MODULE_react__) {
return 